import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { PoDialogService } from '@po-ui/ng-components';


import {
  PoButtonModule,
  PoPageModule,
  PoTableModule,
  PoModalModule,
  PoModalComponent,
  PoFieldModule,
  PoLoadingModule
} from '@po-ui/ng-components';

import { CountService } from '../../shared/service/count.service';
import { TokenService } from '../../shared/service/token.service';
import { ToasterComponent } from '../../shared/components/toaster/toaster.component';

@Component({
  standalone: true,
  selector: 'app-production-order-movement',
  templateUrl: './production-order-movement.component.html',
  styleUrls: ['./production-order-movement.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    PoPageModule,
    PoTableModule,
    PoButtonModule,
    PoModalModule,
    PoFieldModule,
    PoLoadingModule,
    ToasterComponent,
  ]
})
export class ProductionOrderMovementComponent implements OnInit {
  isLoading: boolean = true;
  size = 'sm';
  text = 'Carregando';

  @ViewChild('countModal') countModal!: PoModalComponent;

  items: any[] = [];
  countDescription: string = '';


  columns = [
    {
      property: 'code',
      label: 'Código',
      class: 'align-right',
      headerClass: 'align-right'
    },
    {
      property: 'description',
      label: 'Descrição',
      class: 'description-cell align-left',
      headerClass: 'description-cell align-left'
    },

    {
      property: 'itensCount',
      label: 'Qtd',
      class: 'align-right',
      headerClass: 'align-right'
    },
    {
      property: 'action',
      label: ' ',
      type: 'cellTemplate',
      class: 'align-center',
      headerClass: 'align-center'
    },


  ];





  constructor(
    private countService: CountService,
    private tokenService: TokenService,
    private router: Router,
    private poDialog: PoDialogService
  ) { }

  ngOnInit(): void {
    this.loadOutputCounts();
  }

  private loadOutputCounts(): void {
    const branchCode = Number(this.tokenService.getBranch()!);
    this.isLoading = true;

    this.countService.getPendingOutputCounts(branchCode, this.tokenService.getComponentCode('production-order-movement')!)
      .subscribe({
        next: (response) => {
          this.items = response.items || [];
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Erro ao carregar contagens:', err);

          this.isLoading = false;
          this.items = [];
        }
      });
  }

  openModal(): void {
    this.countDescription = '';
    this.countModal.open();
  }

  saveCount(): void {
    const branchCode = Number(this.tokenService.getBranch());

    this.countService.postCount(branchCode, this.countDescription, this.tokenService.getComponentCode('production-order-movement')!).subscribe({
      next: (res: any) => {
        this.loadOutputCounts();
        this.countModal.close();
        this.router.navigate(['/count-details', branchCode, res.code]);
      },
      error: (err) => {
        console.error('Erro ao criar nova contagem:', err);
      }
    });
  }

  closeModal(): void {
    this.countModal.close();
  }

  goToCountDetails(branchCode: number, code: number): void {
    this.router.navigate(['/count-details', branchCode, code]);
  }

  cancelCount(branchCode: number, code: number): void {
    this.isLoading = true;

    this.countService.postUpdateCountStatus(branchCode, code, 6).subscribe({
      next: () => {
        this.isLoading = false;
        this.items = this.items.filter(item => item.code !== code);
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Erro ao cancelar contagem:', err);
      }
    });
  }

  confirmDeleteCount(branchCode: number, code: number): void {
    this.poDialog.confirm({
      title: 'Confirmar cancelamento',
      message: `Deseja realmente cancelar a contagem ${code}?`,
      confirm: () => this.cancelCount(branchCode, code)
    });
  }

}
